// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import ContentBox from '../ContentBox.jsx';
import PageHeader from '../PageHeader.jsx';
import Table from '../Table.jsx';
import Modal from '../Modal.jsx';
import { Button } from '../Buttons.jsx';

import DrugDispenser from './DrugDispenser.jsx';

import { fetchTransactionHistory } from '../../actions/pharmacyActions';

type Props = {
  transactionHistory: Object[],
  fetchTransactionHistory: Function,
}

type State = {
  modalOpen: boolean,
  activeDrug: ?Object,
}

class TransactionHistoryPageComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      modalOpen: false,
      activeDrug: null,
    };
  }

  componentDidMount() {
    this.props.fetchTransactionHistory();
  }

  openModal = (drug: Object) => {
    this.setState({
      modalOpen: true,
      activeDrug: {
        ...drug,
        _id: drug.drugId,
        category: drug.drugCategory,
      },
    });
  }

  closeModal = () => {
    this.setState({
      modalOpen: false,
      activeDrug: null,
    });
  }

  render() {
    const columns = [
      {
        Header: 'Date',
        id: 'date',
        cell: item => (item.date ? moment(item.date).format() : '--'),
      },
      {
        Header: 'Time',
        id: 'time',
        cell: item => (item.date ? moment(item.date).format('HH:mm') : '--'),
      },
      {
        Header: 'Drug Name',
        id: 'drugName',
        cell: item => item.drugName || '--',
      },
      {
        Header: 'Lot Number',
        id: 'lotNumber',
        cell: item => item.lotNumber || '--',
      },
      {
        Header: 'Action',
        id: 'action',
        cell: item => item.action || '--',
      },
      {
        Header: 'Provider',
        id: 'provider',
        cell: item => item.provider || '--',
      },
      {
        Header: '',
        id: 'viewCol',
        cell: item => !item.deleted && <Button onClick={() => this.openModal(item)}>View Drug</Button>,
        width: 90,
      },
    ];

    return (
      <div>
        <PageHeader title='Transaction Report' />
        <ContentBox>
          <Table
            columns = { columns }
            data = { this.props.transactionHistory || [] }
            style={{}}
            omitNotes
          />
        </ContentBox>
        <Modal isOpen={this.state.modalOpen}>
          <DrugDispenser
            viewOnly
            drug={this.state.activeDrug || {}}
            handleSaveRow={undefined}
            handleSaveNewRow={undefined}
            closeModal={this.closeModal}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  transactionHistory: state.pharmacy.data.transactionHistory,
});

const mapDispatchToProps = dispatch => ({
  fetchTransactionHistory: () => dispatch(fetchTransactionHistory()),
});

const TransactionHistoryPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransactionHistoryPageComponent);

export default TransactionHistoryPage;



// WEBPACK FOOTER //
// ./client/src/components/pharmacyPages/TransactionHistoryPage.jsx